import React, { useEffect, useState } from "react";
// reactstrap components
import {
  Card,
  Container,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { connect } from "react-redux";
import Unauthorized from "views/Pages/Unauthorized";
import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { toast } from "react-toastify";
import qs from "query-string";
import { resetState } from "../../redux/common/commonAction";
import ReactPaginate from "react-paginate";
import Moment from "react-moment";
import { DropdownList } from "react-widgets";
import SendGiftModal from "views/Modal/GiftReceiver/SendGiftModal";

function Gifts(props) {
    const [unauthorized, setUnauthorized] = useState(false);
    const [giftReceivers, setGiftReceivers] = useState([]);
    const [years, setYears] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [sendGiftModal, setSendGiftModal] = useState(false);
    const [editData, setEditData] = useState({
      giftReceiverId: 0,
      amount: 0,
      description: ""
    });
    const [gifts, setGifts] = useState({
      data: [],
      totalRecords: 0,
      error: null
    });
    const [filter, setFilter] = useState({
      page: 0,
      pageSize: 50,
      search: "",
      year: null,
      giftReceiverId: { id: 0, firstName: "", lastName: "" }
    });

    useEffect(() => {
      loadGiftHistory();
      loadGiftReceivers();
      loadGiftYears();
    }, []);

    if (gifts.error && !unauthorized) {
      if (gifts.error.status === 403) {
        setUnauthorized(true);
      } else if (gifts.error.status === 440) {
        toast.error(gifts.error.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        props.history.push("/auth/login");
      }
    }

    const updateQueryString = (params) => {
      const queryString = qs.stringify(params, { skipNull: true, skipEmptyString: true });
      props.history.push({
        pathname: props.location.pathname,
        search: queryString ? `?${queryString}` : "",
      });
    }

    const toggleSendGift = (item) => {
      setEditData(item);
      setSendGiftModal(!sendGiftModal);
    }

    const loadGiftYears = () => {
      GetApiActionWithAuthorization("gift-receivers/gifts-history/get-years")
      .then((res) => {
        setYears(res.data)
      })
      .catch((err) => {
        if (err.status === 403) {
          setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
    };

    const loadGiftReceivers = () => {
      GetApiActionWithAuthorization("gift-receivers/all", filter)
      .then((res) => {
        setGiftReceivers(res.data)
        const id = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id;
        // if id is present in query string, set the selected gift receiver in filter
        if (id) {
          const selectedGiftReceiver = res.data.find((item) => item.id === parseInt(id));
          if (selectedGiftReceiver) {
            setFilter((prevFilter) => ({
              ...prevFilter,
              giftReceiverId: selectedGiftReceiver
            }));
          }
        }
      })
      .catch((err) => {
      if (err.status === 403) {
        setUnauthorized(true);
      } else if (err.status === 440) {
        props.resetState();
        toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
        props.history.push("/auth/login");
      }
      });
    };

    const loadGiftHistory = (params = {}) => {
        let id = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id;
        if (id) {
          params.giftReceiverId = id;
        }
        params = Object.assign(filter, params);
        GetApiActionWithAuthorization("gift-receivers/gifts-history", params)
        .then((res) => {
          setGifts(res)
          console.log("Gifts history: ", res);
          setTotalAmount(res.totalAmount);
        })
        .catch((err) => {
            if (err.status === 403) {
                setUnauthorized(true);
            } else if (err.status === 440) {
                props.resetState();
                props.history.push("/auth/login");
            }
        });
    };
    
  const toggleEdit = (item) => {
    setEditData(item);
    setSendGiftModal(!sendGiftModal);
  };

  const processDeleteGiftHistory = (id) => {
    if (window.confirm("Are you sure you want to delete this gift record ?")) {
      GetApiActionWithAuthorization(`gift-receivers/gifts-history/delete/${id}`)
      .then((res) => {
        toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
        window.document.activeElement.blur();
        loadGiftHistory();
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
    }
  };

  const renderTableData = (e) => {
    return gifts.data.map((item, i) => {
      return (
        <tr key={i}>
          <td>{item.giftReceiver.firstName} {item.giftReceiver.lastName}</td>
          <td>${item.amount}</td>
          <td>{item.description}</td>
          <td>
            <span>
              <Moment format="MM/DD/YY HH:mm" tz="America/Los_Angeles">
                {item.createdAt.toString().length === 10
                  ? new Date(item.createdAt * 1000)
                  : new Date(item.createdAt)}
              </Moment>
            </span>
          </td>
          <td>
            <Button
              size="sm"
              color="warning"
              onClick={() => toggleEdit(item)}
            >
              <i className="fas fa-pencil-alt"></i> Edit
            </Button>
            <Button
              size="sm"
              color="danger"
              onClick={() => processDeleteGiftHistory(item.id)}
            >
              <i className="fas fa-trash-alt"></i> Delete
            </Button>
          </td>
        </tr>
      );
    });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader>
            <div className="text-center">
              <h1>Gifts History</h1>
            </div>
          </CardHeader>
          <CardBody>
            <div className="mb-3">
              <Row className="my-3">
                <Col md="7" className=""></Col>
                <Col md="2" className="">
                  <DropdownList
                    id="giftReceiver"
                    data={giftReceivers}
                    textField={(item) => `${item.firstName || ""} ${item.lastName || ""}`}
                    value={filter.giftReceiverId}
                    onChange={(e) => {
                      updateQueryString({ id: e.id });
                      setFilter({ ...filter, giftReceiverId: e })
                      loadGiftHistory({ ...filter, giftReceiverId: e.id });
                    }}
                  />
                </Col>
                <Col md="2" className="">
                  <DropdownList
                    id="year"
                    data={years}
                    textField="year"
                    value={filter.year}
                    onChange={(e) => {
                      updateQueryString({ year: e.year });
                      setFilter({ ...filter, year: e.year })
                      loadGiftHistory({ ...filter, year: e.year, giftReceiverId: filter.giftReceiverId.id });
                    }}
                  />
                </Col>
                <Col md="1" className="">
                  <Button
                    type="button"
                    color="primary"
                    onClick={() => {
                      window.location.href = "/portal/gift-receivers";
                    }}
                    >
                    <i className="fas fa-chevron-left"></i> Back
                  </Button>
                </Col>
              </Row>
            </div>
            <div style={{float: 'right', fontSize: '16px'}}>
              <div>
                <span className="mr-1">Total Gift Amount:</span>
                <strong>${totalAmount}</strong>
              </div>
            </div>
            <Table className="coin-table border-top-none" responsive bordered>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Receiver</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Description</th>
                  <th scope="col">Date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>{renderTableData()}</tbody>
            </Table>
            {gifts.totalRecords > 0 && (
                <ReactPaginate
                  previousLabel={<i className="fas fa-chevron-left"></i>}
                  nextLabel={<i className="fas fa-chevron-right"></i>}
                  breakLabel={".."}
                  breakClassName={"break-me"}
                  initialPage={filter.page}
                  pageCount={Math.ceil(gifts.totalRecords / filter.pageSize)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => {
                    //run only when page changes
                    if (filter.page !== e.selected) {
                        loadGiftHistory({
                            page: e.selected,
                            pageSize: filter.pageSize,
                            search: filter.search,
                        });
                        setFilter({
                            ...filter,
                            page: e.selected,
                        });
                    }
                  }}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              )}
          </CardBody>
        </Card>
      </Container>
      {sendGiftModal && (
        <SendGiftModal
          {...props}
          show={sendGiftModal}
          data={editData}
          giftReceivers={giftReceivers}
          toggle={toggleSendGift}
          reloadHistory={loadGiftHistory} />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetState: () => dispatch(resetState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Gifts);